<template>
    <div class="card" :style="'border-top:3px solid ' + appointment.colors">
        <div class="card-body p-3">
            <div class="row align-items-center">
                <div class="col">
                    <h4>{{ appointment.startAt | moment('LT') }} - {{ appointment.endAt | moment('LT') }}</h4>
                </div>
                <div class="col-auto small">
                    <status-badge class="pointer" :status="appointment.status" @click="toggleAppointmentStatus" :iconOnly="false"></status-badge>
                </div>
                <!-- <div class="col-auto">{{ appointment.totalPrice}}</div> -->
            </div>
            <div class="row align-items-start">
                <div class="col">
                    <div class="row align-items-center">
                        <div class="col-auto">
                            <avatar
                                type="circle"
                                v-if="appointment.customer.avatar"
                                :src="appointment.customer.avatar.preview"
                                size="avatar-xs"
                            ></avatar>
                        </div>
                        <div :id="popoverId" class="col p-0">
                            {{ appointment.customer.first_name }}
                            {{ appointment.customer.last_name }}
                        </div>
                    </div>
                    <div class="row" v-if="appointment.customer.tags">
                        <div class="col">
                            <tag-pills :tags="appointment.customer.tags"/>
                        </div>
                    </div>
                    <div class="mb-4"></div>

                    <div
                        :id="popoverServiceId"
                        v-for="(service, index) in appointment.services"
                        :key="index"
                        class="row align-items-start mt-1"
                    >
                        <div class="col" v-if="service.user">
                            {{ service.user.firstName }} {{ service.user.lastName }}
                            <div
                                class="small text-muted"
                                v-if="service && service.treatment && service.duration"
                            >{{ service.duration | duration }} {{ service.treatment.label }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer1 p-2 border-top">
            <div class="row">
                <div class="col-auto">
                    <button
                        class="btn btn-white mr-2"
                        v-if="appointment.status == 'confirmed' || appointment.status == 'notConfirmed' || appointment.status == 'new'"
                        @click="status('arrived')"
                    >
                        <i class="fe fe-arrow-right"></i>
                    </button>
                    <button
                        v-if="appointment.status == 'arrived'"
                        class="btn btn-white mr-2"
                        @click="status('confirmed')"
                    >
                        <i class="fe fe-arrow-left"></i>
                    </button>
                    <button
                        v-if="appointment.status == 'started'"
                        class="btn btn-white mr-2"
                        @click="status('arrived')"
                    >
                        <i class="fe fe-arrow-left"></i>
                    </button>

                    <button class="btn btn-success" v-if="appointment.status == 'arrived'" @click="status('started')">
                        <i class="fe fe-arrow-right"></i>
                    </button>

                    <button v-if="appointment.status == 'started'" class="btn btn-dark" @click="openCheckoutModal">
                        <i class="fe fe-dollar-sign"></i>
                    </button>
                </div>
                <div class="col"></div>
                <div class="col-auto">
                    <a :href="'tel:' + appointment.customer.phone" class="btn btn-outline-info mr-2">
                        <i class="fe fe-phone"></i>
                    </a>
                    <button class="btn btn-white" @click="view(appointment)">
                        <i class="fe fe-eye"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue';
import { mapActions, mapGetters } from 'vuex';
import { modalMixins } from '@/mixins/modal.js';
import duration from '@/filters/duration.js';
import StatusBadge from '@/components/StatusBadge';
import TagPills from '@/components/TagPills.vue';

export default {
    mixins: [modalMixins],
    props: ['appointment', 'view'],
    filters: { duration },

    components: {
        Avatar,
        StatusBadge,
        TagPills
    },
    computed: {
        ...mapGetters('customers', { getCustomer: 'get' }),
        customer() {
            return this.getCustomer(this.appointment.customerId);
        },
        popoverServiceId() {
            return 'service-' + this.appointment._id;
        },
        popoverId() {
            return 'customer-' + this.appointment._id;
        }
    },
    methods: {
        ...mapActions('appointment', ['patch']),
        status(status) {
            this.patch([this.appointment._id, { status }])
        },
        toggleAppointmentStatus() {
            if (this.appointment.status === 'arrived' && this.appointment.status === 'started')
                return
            let status = 'confirmed'
            if (this.appointment.status === 'confirmed')
                status = 'notConfirmed';
            this.patch([this.appointment._id, { status }]);
        },
        openCheckoutModal() {
            let details = {
                appointment: this.appointment,
                _id: 'temp'
            };
            const { Appointment } = this.$FeathersVuex;
            new Appointment(details);
            this.openModal({ id: 'CheckoutModal' });

        },
    }


}
</script>

<style scoped>
.card:hover {
    cursor: move;
}
</style>
